import {WhitelabelEventWithPayload} from "../../../common/ts/events/Events";

export enum PushManagerSubscriptionStatus {
    GRANTED = 'granted',
    ALLOWED = 'allow',
}

interface PushManagerSubscriptionCreatedPayload {
    endpoint: string,
    auth: string,
    key: string,
    status: PushManagerSubscriptionStatus
}

export class PushManagerSubscriptionCreatedEvent implements WhitelabelEventWithPayload<PushManagerSubscriptionCreatedPayload> {
    payload: PushManagerSubscriptionCreatedPayload
    type: string;
    static readonly TYPE: string = 'web-push-subscription-created';

    constructor(payload: PushManagerSubscriptionCreatedPayload) {
        this.type = PushManagerSubscriptionCreatedEvent.TYPE;
        this.payload = payload;
    }
}
